<template>
  <v-container>
    <v-row>
      <v-col>
        <TextEditor
          title="API URL"
          v-model="value.api"
          :table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          hide-details
          filled
          label="Method"
          v-model="value.method"
          :items="['GET', 'POST', 'PUT', 'DELETE']"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ScriptParamsEditor
          title="Parameters"
          v-model="value.params"
          :containers="containers"
          :component="component"
          :table="table"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DataOutputPicker title="Save output to" v-model="value.output" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ScriptParamsEditor from "../shared/ScriptParamsEditor.vue";
import DataOutputPicker from "../shared/DataOutputPicker.vue";
import TextEditor from "../shared/TextEditor.vue";

export default {
  name: "CallApiDesigner",

  components: { DataOutputPicker, ScriptParamsEditor, TextEditor },

  props: ["value", "containers", "table", "component"],
};
</script>
